








































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from "vue";
import { createNamespacedHelpers } from "vuex";
import rgbaHex from "rgb-hex";

import FormBackgroundImage from "@/components/formbuilder/FormBackgroundImage.vue";
import Font from "@/components/websitebuilder/Font.vue";
import FormSelector from "@/components/websitebuilder/FormSelector.vue";
import shopStoreModule from "@/store/modules/shop";
import siteStoreModule from "@/store/modules/site";
import serviceStoreModule from "@/store/modules/service";
import termsStoreModule from "@/store/modules/terms";
import cancellationPolicyStoreModule from "@/store/modules/cancellationPolicy";
import locationStoreModule from "@/store/modules/location";
import serviceCategoryStoreModule from "@/store/modules/serviceCategory";
import {
  Business,
  File as _File,
  Form,
  Product,
  Role,
  Service,
  User,
  Terms,
  CancellationPolicy,
  Site,
  SiteSettings,
  Shop,
} from "@/types";

const { mapActions: shopActions } = createNamespacedHelpers("SITE_SHOP_DETAIL");

const { mapActions: siteActions } = createNamespacedHelpers("SITE");

const { mapActions: servicesActions, mapGetters: servicesGetters } =
  createNamespacedHelpers("SITE_SERVICES");

const { mapActions: termsActions } = createNamespacedHelpers("TERMS");
const { mapActions: cancellationPolicyActions } = createNamespacedHelpers(
  "CANCELLATION_POLICY"
);
const { mapActions: locationActions, mapGetters: locationGetters } =
  createNamespacedHelpers("LOCATION_LIST");
const { mapActions: serviceCatActions } =
  createNamespacedHelpers("SERVICE_CAT_LIST");

const API_URL = process.env.VUE_APP_API_URL;
const AHIDI_DOMAIN = process.env.VUE_APP_AHIDI_DOMAIN;

let pos1 = 0,
  pos2 = 0,
  pos3 = 0,
  pos4 = 0;

type OptionValue = {
  _id: string;
  value: string;
};

type OptionSet = {
  _id: string;
  business: string | Business;
  option_name: string;
  option_values: OptionValue[];
};

type ShopCartItem = {
  images: _File[];
  name: string;
  price: number;
  description: string;
  _id: string;
  quantity: number;
  ratings: number;
  type: "product" | "service" | "membership";
  option_set?: OptionSet[];
};

type SKU = {
  pricing: {
    supply_price: number;
    retail_price: number;
    last_price: number;
  };
  product: Product;
  title: string;
  sku: string;
  _id: string;
};

declare global {
  interface Window {
    filterProducts: (filter: string) => void;
  }
}

export default Vue.extend<any, any, any, any>({
  components: { FormBackgroundImage, Font, FormSelector },
  data: () => ({
    bgDialog: false,
    fontDialog: false,
    el: undefined as undefined | { item: HTMLElement; name: string },
    title: "",
    homeDescriptionCount: 1,
    servicesDescriptionCount: 1,
    contactDescriptionCount: 1,
    logoDialog: false,
    page: "Home",
    backgroundImage: "",
    logoImage: "",
    linkMenuDialog: false,
    resizeLogoDialog: false,
    logoSize: 95,
    status: "Active",
    saveDialog: false,
    showShopName: true,
    fullScreen: false,
    saving: false,
    shopNameSnackbar: false,
    selectShopDialog: false,
    showShop: false,
    formDialog: false,
    form: undefined as undefined | Form,
    termsDialog: false,
    termsRules: [
      (value: File) => !!value || "A file is required",
      (value: File) =>
        !value || value.type == "application/pdf" || "Only PDF files allowed",
    ],
    cancellationPolicyRules: [
      (value: File) => !!value || "A file is required",
      (value: File) =>
        !value || value.type == "application/pdf" || "Only PDF files allowed",
    ],
    termsFile: undefined as undefined | File,
    apiUrl: API_URL,
    termsValid: false,
    loading: true,
    cancellationPolicyDialog: false,
    cancellationPolicyFile: undefined as undefined | File,
    cancellationPolicyValid: false,
    showMembership: false,
    showVouchers: false,
    showGallery: false,
    showEmail: false,
    showLocation: false,
    ahidiUrl: "https://" + AHIDI_DOMAIN,
    showServices: false,
    site: undefined as undefined | Site,
    updatesAvailable: false,
    colors: {
      bgColor: "#FF000004",
      fontColor: "#F48203",
    },
    themeColorDialog: false,
    themeColor: "#F48203",
    removedElements: [] as { item: HTMLElement; name: string }[],
    reverseRemoveDialog: false,
    zoomLevel: 1.0,
    meta: {
      backgroundImage: "",
      logoImage: "",
    },
    settings: undefined as undefined | SiteSettings,
    mainStyle: {},
    loadingSite: false,
    bid: null,
  }),
  computed: {
    //...shopGetters(["shop"]),
    ...servicesGetters(["servicePage"]),
    ...locationGetters(["locationPage"]),
    user(): User {
      return this.$store.getters.user;
    },
    role(): Role {
      return this.$store.getters.role;
    },
    domain(): string {
      const domain = AHIDI_DOMAIN;
      return `${this.shop?.name
        .replace(/[|&;$%@'"<>()+,.]/g, "")
        .replace(/\s/g, "")
        .toLowerCase()}.${domain}`;
    },
    terms(): Terms {
      return this.$store.getters["TERMS/getTerms"](this.shop?._id);
    },
    cancellationPolicy(): CancellationPolicy {
      return this.$store.getters["CANCELLATION_POLICY/getCancellationPolicy"](
        this.shop?._id
      );
    },
    shop(): Shop {
      return this.$store.getters["SITE_SHOP_DETAIL/shop"];
    },
  },
  watch: {
    showShopName() {
      this.shopNameSnackbar = !this.showShopName;
    },
    role: "setUp",
  },
  methods: {
    ...shopActions(["fetchShop"]),
    ...siteActions([
      "createSite",
      "fetchSite",
      "updateFiles",
      "fetchSiteSettings",
      "uploadImage",
    ]),
    ...servicesActions(["fetchServiceList"]),
    ...termsActions(["fetchTerms", "createTerms", "updateTerms"]),
    ...cancellationPolicyActions([
      "fetchCancellationPolicy",
      "createCancellationPolicy",
      "updateCancellationPolicy",
    ]),
    ...locationActions(["fetchLocationList"]),
    ...serviceCatActions(["fetchServiceCategoryList"]),
    async setUp() {
      if (this.role && !this.shop) {
        const bid = (this.role.business as Business)._id;
        this.bid = bid;
        const settings: SiteSettings = await this.fetchSiteSettings();
        this.settings = settings;
        this.backgroundImage = `url(${API_URL}/v1/file/${settings.defaultBackgroundImage.filename})`;
        this.mainStyle = { backgroundImage: this.backgroundImage };

        const site: Site = await this.fetchSite(`?businessId=${bid}`);
        if (site) {
          this.loadingSite = false;
          this.site = site;
          const siteName = site.shop.name
            .replace(/[|&;$%@'"<>()+,.]/g, "")
            .replace(/\s/g, "")
            .toLowerCase();
          this.updatesAvailable = settings.currentVersion != this.site?.version;
          this.backgroundImage = `url(${API_URL}/v1/static/image/${siteName}/${site.meta.backgroundImage})`;
          this.logoImage = `${API_URL}/v1/static/image/${siteName}/${site.meta.logoImage}`;

          this.themeColor = this.site.meta.themeColor;
          this.mainStyle = { backgroundImage: this.backgroundImage };
          this.meta = site.meta;

          setTimeout(() => {
            const desc = document.getElementById(
              "home-description"
            ) as HTMLDivElement;
            const title = document.getElementById(
              "home-title-heading"
            ) as HTMLDivElement;

            if (site.meta) {
              desc.innerHTML = site.meta?.description;
              title.innerHTML = site.meta?.title;
            }
          }, 500);
          this.showShopName = site.meta?.showShopName;

          if (!this.updatesAvailable) {
            this.$router.push(`/website-builder/${site._id}`);
          }
        }

        this.fetchShop(`?businessId=${bid}`).then(async (shop) => {
          //this.loadingSite = true;
          if (shop) {
            this.loading = false;
            this.title = shop.name;
            this.fetchTerms(`?shopId=${shop._id}`).then((terms) => {
              if (terms) this.terms = terms;
            });
            this.fetchCancellationPolicy(`?shopId=${shop._id}`).then(
              (policy) => {
                if (policy) this.cancellationPolicyFile = policy;
              }
            );
            setTimeout(() => {
              this.addShop();
              this.addContactForm();
              this.addGallery();
              this.addServices();
              this.setUpCart();
              this.setUpOrder();
              this.addCardPaymentForm();
              this.addProductCategories();
              this.setUpVouchers();
              this.setUpMemberships();
              this.getServiceCategories();
              const copyrightYear = document.getElementById("copyright-year");
              (copyrightYear as HTMLSpanElement).innerHTML = new Date()
                .getFullYear()
                .toString();

              this.applyThemeColor();
            }, 500);
          } else if (!shop) this.loading = false;
        });
        this.fetchServiceList(`?businessId=${bid}`).then((page) => {
          if (page && page.docs.length) {
            this.showServices = true;
          }
        });
        this.fetchLocationList(`?businessId=${bid}`).then((page) => {
          if (page && page.docs.length) {
            this.showLocation = true;
          }
        });
      }
    },
    getHtml(section: string) {
      const el = document.querySelector(`#${section}`) as HTMLElement;
      return el ? `<!DOCTYPE html>` + el.innerHTML : "";
    },
    save() {
      this.saving = true;
      this.mainStyle = {};
      this.logoImage = "";
      const homeDesc = document.getElementById("home-description");
      const homeTitleHeading = document.getElementById("home-title-heading");
      const homeTitle = document.getElementById("home-title");

      const servicesDesc = document.getElementById("services-description");
      const servicesTitle = document.getElementById("services-title");
      const contactTitle = document.getElementById("contact-title-heading");
      const contactDesc = document.getElementById("contact-description");

      homeDesc?.removeAttribute("contenteditable");
      homeTitleHeading?.removeAttribute("contenteditable");
      homeTitle?.removeAttribute("draggable");
      servicesDesc?.removeAttribute("contenteditable");
      servicesTitle?.removeAttribute("contenteditable");
      contactTitle?.removeAttribute("contenteditable");
      contactDesc?.removeAttribute("contenteditale");

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const payload: { [key: string]: string & any } = {
        shopId: this.shop._id,
        homePage: "",
        servicesPage: "",
        galleryPage: "",
        shopPage: "",
        contactPage: "",
        productDetailPage: "",
        cartPage: "",
        paymentPage: "",
        membershipPage: "",
        voucherPage: "",
        formPage: "",
        bookServicePage: "",
        loginPage: "",
        registerPage: "",
        forgotPasswordPage: "",
        locationPage: "",
        domain: this.domain,
        businessId: (this.role.business as Business)._id,
        status: this.status.toLowerCase(),
        meta: {
          description: homeDesc?.innerText || "",
          title: homeTitle?.innerText || "",
          backgroundImage:
            this.meta.backgroundImage ?? this.settings?.defaultBackgroundImage,
          logoImage: this.meta.logoImage,
          showShopName: this.showShopName,
          showContact: this.showEmail,
          themeColor: this.themeColor,
        },
      };

      [
        "home",
        "services",
        "gallery",
        "shop",
        "contact",
        "cart",
        "payment",
        "membership",
        "voucher",
        "form",
        "bookService",
        "productDetail",
        "login",
        "register",
        "forgotPassword",
        "location",
      ].map((section) => {
        const code = this.getHtml(section);

        payload[`${section}Page`] = code;
      });

      const editables = document.querySelectorAll('[contenteditable="true"]');
      editables.forEach((el) => el.removeAttribute("contenteditable"));

      const wrapper1 = document.getElementById(
        "book-service-wrapper"
      ) as HTMLDivElement;
      const wrapper2 = document.getElementById(
        "confirm-service-wrapper"
      ) as HTMLDivElement;

      if (wrapper1) wrapper1.style.display = "block";
      if (wrapper2) wrapper2.style.display = "none";
      if (this.site && this.site._id) {
        payload["siteId"] = this.site._id;
        this.updateFiles(payload).then((site) => {
          this.saving = false;
          if (site) {
            this.updatesAvailable = false;
            // localStorage.removeItem("shopId");
            this.$router.push(`/website-builder/${site._id}`);
          } else {
            this.mainStyle = { backgroundImage: this.meta.backgroundImage };
            this.logoImage = `${API_URL}/v1/file/${this.meta.logoImage}`;
          }
        });

        return;
      }

      this.backgroundImage = "";

      this.createSite(payload).then((site) => {
        this.saving = false;
        if (site) {
          this.saveDialog = false;
          // localStorage.removeItem("shopId");
          this.$router.push(`/website-builder/${site._id}`);
        } else {
          this.mainStyle = { backgroundImage: this.backgroundImage };
        }
      });
    },
    dragStart(evnt: DragEvent) {
      pos3 = evnt.clientX;
      pos4 = evnt.clientY;
    },
    dragEnd(evnt: DragEvent, el: HTMLElement) {
      pos1 = pos3 - evnt.clientX;
      pos2 = pos4 - evnt.clientY;

      if (!el) return;
      el.style.top = el.offsetTop - pos2 + "px";
      el.style.left = el.offsetLeft - pos1 + "px";
      pos1 = 0;
      pos2 = 0;
      pos3 = 0;
      pos4 = 0;
    },
    doubleClick(el: HTMLElement) {
      el.contentEditable = "true";
    },
    displayBg(image: File) {
      const payload = new FormData();
      payload.append("file", image);
      this.uploadImage({ type: "backgroundImage", payload }).then((res) => {
        if (res) {
          this.meta.backgroundImage = res.file.filename;
          this.bgDialog = false;
          const reader = new FileReader();
          reader.onloadend = () => {
            this.backgroundImage = `url(${API_URL}/v1/file/${res.file.filename})`;
            this.mainStyle = {
              backgroundImage: `url(${API_URL}/v1/file/${res.file.filename})`,
            };
          };

          reader.readAsDataURL(image);
        }
      });
    },
    mobileView() {
      const viewer = document.getElementById("viewer") as HTMLElement;
      const mobileHeaders = document.getElementsByClassName("mobile-header");
      const desktopHeaders = document.getElementsByClassName("header");

      for (let i = 0; i < mobileHeaders.length; i++) {
        const div1 = mobileHeaders[i] as HTMLDivElement;
        const div2 = desktopHeaders[i] as HTMLDivElement;

        div1.style.display = "flex";
        div2.style.display = "none";
      }

      viewer.style.width = "390px";
      viewer.style.margin = "auto";

      const homeTitle = document.getElementById("home-title") as HTMLDivElement;
      homeTitle.style.left = "10px";
      homeTitle.style.maxWidth = "90%";
      homeTitle.style.top = "100px";

      const homeDescription = document.getElementById(
        "home-description"
      ) as HTMLElement;
      homeDescription.style.maxWidth = "90%";
      homeDescription.style.left = "10px";
      homeDescription.style.top = "150px";

      const footers = document.getElementsByClassName("site-footer");

      for (let j = 0; j < footers.length; j++) {
        const element = footers.item(j) as HTMLDivElement;
        element.style.paddingLeft = "5px";
        element.style.paddingRight = "5px";
      }

      const contentDivs = document.getElementsByClassName("content");
      for (let k = 0; k < contentDivs.length; k++) {
        const element = contentDivs.item(k) as HTMLDivElement;
        element.style.minHeight = "calc(94vh - 180px)";
        // element.style.overflow = "scroll";
      }
      const goToShopLink = document.getElementsByClassName("go-to-shop-link");
      (goToShopLink[0] as HTMLElement).style.position = "relative";
      // (goToShopLink[0] as HTMLElement).style.top = "490px";
      (goToShopLink[0] as HTMLElement).style.left = "calc(50% - 115px)";

      const scheduleLink = document.getElementsByClassName("schedule-link");
      (scheduleLink[0] as HTMLElement).style.position = "relative";
      // (scheduleLink[0] as HTMLElement).style.top = "490px";
      (scheduleLink[0] as HTMLElement).style.left = "calc(50% - 140px)";
    },
    desktopView() {
      const home = document.getElementById("viewer") as HTMLElement;
      const mobileHeaders = document.getElementsByClassName("mobile-header");
      const desktopHeaders = document.getElementsByClassName("header");

      for (let i = 0; i < mobileHeaders.length; i++) {
        const div1 = mobileHeaders[i] as HTMLDivElement;
        const div2 = desktopHeaders[i] as HTMLDivElement;

        div1.style.display = "none";
        div2.style.display = "flex";
      }

      home.style.width = "65vw";
      home.style.margin = "unset";

      const goToShopLink = document.getElementsByClassName("go-to-shop-link");
      (goToShopLink[0] as HTMLElement).style.position = "relative";
      (goToShopLink[0] as HTMLElement).style.top = "490px";
      (goToShopLink[0] as HTMLElement).style.left = "75px";

      const scheduleLink = document.getElementsByClassName("schedule-link");
      (scheduleLink[0] as HTMLElement).style.position = "relative";
      (scheduleLink[0] as HTMLElement).style.top = "490px";
      (scheduleLink[0] as HTMLElement).style.left = "90px";

      const homeTitle = document.getElementById("home-title") as HTMLDivElement;
      homeTitle.style.left = "75px";
      homeTitle.style.maxWidth = "450%";
      homeTitle.style.top = "280px";

      const homeDescription = document.getElementById(
        "home-description"
      ) as HTMLElement;
      homeDescription.style.maxWidth = "450px";
      homeDescription.style.left = "75px";
      homeDescription.style.top = "380px";

      const footers = document.getElementsByClassName("site-footer");

      for (let j = 0; j < footers.length; j++) {
        const element = footers.item(j) as HTMLDivElement;
        element.style.paddingLeft = "50px";
        element.style.paddingRight = "50px";
      }
    },
    drop(ev: DragEvent, element: string) {
      // if (element === "heading") {
      //   this.titles.push(`Title ${this.titles.length - 1}`);
      // } else
      if (element === "description") {
        if (this.page === "Home") this.homeDescriptionCount += 1;
        if (this.page === "Services") this.servicesDescriptionCount += 1;
        if (this.page === "Contact") this.contactDescriptionCount += 1;
      }
    },
    displayLogo(image: File) {
      const payload = new FormData();
      payload.append("file", image);
      this.uploadImage({ type: "logoImage", payload }).then((res) => {
        if (res) {
          this.meta.logoImage = res.file.filename;
          this.logoDialog = false;
          const reader = new FileReader();
          reader.onloadend = () => {
            this.logoImage = `${API_URL}/v1/file/${res.file.filename}`;
          };

          reader.readAsDataURL(image);
        }
      });
    },
    handleTermsUpload(file: File) {
      this.termsFile = file;
    },
    uploadTerms() {
      if (!this.termsValid) return;

      const payload = new FormData();

      payload.append("shopId", this.shop._id);
      payload.append("file", this.termsFile as File);
      if (this.terms?._id) {
        this.updateTerms({ id: this.terms._id, terms: payload }).then(
          (terms) => {
            if (terms) {
              this.termsDialog = false;
              this.termsValid = false;
            }
          }
        );
        return;
      }
      this.createTerms(payload).then((terms) => {
        if (terms) {
          this.termsDialog = false;
          this.termsValid = false;
        }
      });
    },
    handleCancellationPolicyUpload(file: File) {
      this.cancellationPolicyFile = file;
    },
    uploadCancellationPolicy() {
      if (!this.cancellationPolicyValid) return;

      const payload = new FormData();

      payload.append("shopId", this.shop._id);
      payload.append("file", this.cancellationPolicyFile as File);
      if (this.cancellationPolicy?._id) {
        this.updateCancellationPolicy({
          id: this.cancellationPolicy._id,
          cancellationPolicy: payload,
        }).then((policy) => {
          if (policy) {
            this.cancellationPolicyDialog = false;
            this.cancellationPolicyValid = false;
          }
        });
        return;
      }
      this.createCancellationPolicy(payload).then((policy) => {
        if (policy) {
          this.cancellationPolicyDialog = false;
          this.cancellationPolicyValid = false;
        }
      });
    },
    addServices() {
      const bid = (this.role.business as Business)._id;
      const url = `${API_URL}/v1/service?businessId=${bid}&limit=0`; // &status=active&_status=active

      fetch(url)
        .then((res) => res.json())
        .then((response) => {
          if (response.servicePage?.docs && response.servicePage.docs.length) {
            let servicesDiv = document.getElementById(
              "services-list"
            ) as HTMLDivElement;

            servicesDiv.innerHTML = "";

            for (let i = 0; i < response.servicePage.docs.length; i++) {
              const service = response.servicePage.docs[i];

              const serviceDiv = document.createElement("div");
              const serviceTitleDiv = document.createElement("div");
              const serviceButton = document.createElement("button");
              const serviceImage = document.createElement(
                "img"
              ) as HTMLImageElement;

              serviceImage.setAttribute("class", "product-image");

              if (service.images.length) {
                const file = service.images[0];

                serviceImage.src = `${API_URL}/v1/file/${file.filename}`;
              } else {
                serviceImage.src = `data:image/png;base64,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`;
              }

              serviceDiv.setAttribute("class", "service");
              serviceTitleDiv.setAttribute("class", "service-title");
              serviceImage.setAttribute("class", "service-description");
              serviceButton.setAttribute("class", "service-button");

              serviceTitleDiv.innerHTML = service.name;
              serviceButton.innerHTML = "Book";
              serviceButton.onclick = () => {
                localStorage.setItem("serviceId", service._id);
                // window.location.href = "/book-service.html";
                this.getServicesForBooking();
              };

              serviceDiv.append(serviceTitleDiv);
              serviceDiv.append(serviceImage);
              serviceDiv.append(serviceButton);

              servicesDiv.append(serviceDiv);
            }

            const contentDiv = document.getElementById(
              "services-content"
            ) as HTMLDivElement;
            contentDiv.append(servicesDiv);
          }
        });
    },
    setUpAppointmentPage() {
      const serviceId = localStorage.getItem("serviceId");

      if (!serviceId) return;

      const url = `${API_URL}/v1/service?serviceId=${serviceId}`;
      fetch(url)
        .then((res) => res.json())
        .then((response) => {
          if (response.service) {
            const formHeader = document.getElementById(
              "appointment-form-header"
            ) as HTMLDivElement;
            formHeader.innerHTML = `Book ${response.service.name} Appointment`;

            const bookBtn = document.createElement("button");

            bookBtn.innerHTML = "Book Appointment";
            bookBtn.classList.add("book-btn");
            bookBtn.style.border = "none";
            bookBtn.type = "submit";
            formHeader.append(bookBtn);

            const virtualField = document.getElementById(
              "virtual-service"
            ) as HTMLInputElement;

            virtualField.disabled = !response.service.virtual;

            const files = response.service.images;

            const imageDiv = document.getElementById(
              "service-image"
            ) as HTMLDivElement;
            if (files.length) {
              const file = files[0];

              imageDiv.style.backgroundImage = `url(${API_URL}/v1/file/${file.filename})`;
            } else {
              imageDiv.style.backgroundPositionY = "-135px";
              imageDiv.style.backgroundImage = `url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAADhCAYAAAByfIirAAAFuUlEQVR4nO3dz2sUZxwH4I9LCCGEJYQgIhJCkBBEJEiQUnoo/ZtLz1Kkpx7EQw+l9CSliIRQQgkipYfXpY1ukt1kZmfemeeBXDTGF9/Zj+/P7yQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQOXudd0ArjVJspFkreuGjMhFkg9dN4L5fBD67VmSJ9FPq/RXkpdJzjpuB3NMum4AV1pPchhhtWrTJI+7bgTzCaz+ElTd8W/fUzqmHqdJ3nbdiIGajWb9B95zAqsep0led92IgdpMmQYKrJ7TQUA1BBZQDYEFVENgAdWw6D48O0l2U/r2Ism7JOedtggaIrCG42GS5ymB9bm3SX5OOcUN1RJYw3CUElZX9eejlFHXy5QRF1TJGlb9HuT6sJrZSPJNypkjqJLAqtski4XVzFaSp+01B9olsOq2k/lrVtfZS7mKAtURWHXbyfJ9uJ4y0oLqCKy63WbTZBL9TqU8uHW7uMWf+SfJx6YbAqsgsOp2muXD5+84SEqlBFbdzpL8ueSf+S39GGFNU2pQ7accuYAbOThav9cph0IX+dC/T/Jru81ZyGHKcYzZbuV5kp+yfPgyMkZY9TtN8io3v+nlLMmPC3xf2/aSvMjloxVbSb5Ncr+LBlEPgTUMfyT5Psnv+TKQzpO8SfJDul+72krydeY/d+uffs/0kCuZEg7HecpIayNlfWhWreE83Y+qktKer3P9odVpyujrVcpuJlwisIbnIrc77tC2Zyn3Hm+yn7KW1Ye1NnrGlJBV2Et5IeyinqdsJMAlAou2baZM85Z51taTfBV3HvmMwKJNk5TguU1Jm50kJ802h9oJLNr0NKV44G09TnLQUFsYAIFFWx6kmdpbJ0m2G/g5DIDAog2zM1VN7EJvpEwr7WgjsGjcJCWsmqy5dT9l55CRE1g07TDlGEMbP/cu62EMgMCiSbtJjlv62bMdR9VSR0xgjdtayi7cScoI5i7nntZS3srT5tmpzTS3NkaFdPx4zV779fB/v/YkpaLD6ZI/a5ISetNmmnatByntfLOCv4ueMcIarxe5HFZJCZzvsnzw7KecmVqVZ1GKZpQE1jgdpYTMPMtOu7az/NWbu5rES2FHSWCNzyIL4/cX+J5ksZIxbdnK6oOSjunscVnmUvFRvpwyfu443VZV2EvZLGAkBNa4vMjib4q+6QDofkqode0kStGMhsAaj4Msf5F4M/OvxUxTgqIPz88sWJVWHoE+PHC0bzu3L9XyMJdHUncpGdOW7bi6MwoCa/iaeLnDcf47RrBoqeNVO4j1rMETWMPXxML4bNp1kOVKHa/SJGWUpRTNgAmsYXuU5kYd0/T/WkyTZW3oIYE1XNOUtaYm+7iG52U31rMGq4YHkOWtpRxh6NPC+Cod5uqT/FRMYA3Tk9x86HPIJhl3YA+WwBqeByk7eWM3q0ZhPWtABNawzC4u69eiqRdh0BMe7OGYTYNU5Lxs7NPjQRFYw3GUdmqp125WCdV61gAIrGFos5b6EGykjD6tZ1VOYNXPYcnFKEUzAAKrbrN1K9dRFnOcft6DZEECq26P44DkMtayeAFDekhg1WuacgVFHy5nGqWVq6XT6rSe9t8BOGQHWe1bfmiIhdo6bSd5/+mL29lMef4/dt0QFiew6vTu0xeMisCqxySmgG3xOaiEjqrHXlwxaZPPQgV0Uj3Wor8YObuE/fUhyUXXjRips64bwHz3um4A19pNudRsZLU6p0l+id1DAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIA2/AvQNmMLb5ClIQAAAABJRU5ErkJggg==)`;
            }

            const locationField = document.getElementById(
              "location-feild"
            ) as HTMLSelectElement;
            locationField.name = "location";

            locationField.innerHTML = "";

            for (var i = 0; i < response.service.advancedPricing.length; i++) {
              const option = document.createElement("option");

              option.value = response.service.advancedPricing[i].location;
              option.innerText = response.service.advancedPricing[i].location;

              locationField.append(option);
            }
          }
        });

      const serviceBookingForm = document.getElementById(
        "appointment-form"
      ) as HTMLFormElement;

      serviceBookingForm.onsubmit = (ev) => {
        ev.preventDefault();

        const data = new FormData(serviceBookingForm);
        const div = document.getElementById("booking-error") as HTMLDivElement;
        div.style.display = "none";

        if (!data.get("time")) {
          div.style.display = "block";
          return;
        }

        const payload = {
          date: data.get("time"),
          virtual: data.get("virtual"),
          notes: data.get("notes"),
          serviceId: localStorage.getItem("serviceId"),
          location: data.get("location"),
        };

        localStorage.setItem("service-booking", JSON.stringify(payload));
        const wrapper1 = document.getElementById(
          "book-service-wrapper"
        ) as HTMLDivElement;
        const wrapper2 = document.getElementById(
          "confirm-service-wrapper"
        ) as HTMLDivElement;

        wrapper1.style.display = "none";
        wrapper2.style.display = "block";
        this.setUpAppointmentConfirmPage();
      };

      this.setUpAppointmentDates();
      this.configureDateButtons();

      const link = document.getElementById(
        "waitlist-link"
      ) as HTMLAnchorElement;

      const modal = document.getElementById("waitlist-modal") as HTMLDivElement;

      link.onclick = (ev: Event) => {
        ev.preventDefault();
        const data = new FormData(serviceBookingForm);
        const div = document.getElementById("booking-error") as HTMLDivElement;
        div.style.display = "none";

        if (!data.get("time")) {
          div.style.display = "block";
          return;
        }

        modal.style.display = "block";
      };

      const button = document.getElementById(
        "waitlist-button"
      ) as HTMLButtonElement;

      button.onclick = () => {
        // const data = new FormData(serviceBookingForm);
        // const payload = {
        //   startDate: data.get("time"),
        //   businessId: "",
        //   clientId: "",
        //   serviceId: localStorage.getItem("serviceId"),
        //   employeeId: "",
        //   notes: data.get("notes"),
        // };
        // console.log("waitlisting... ", payload);
      };

      const overlay = document.getElementById(
        "waitlist-overlay"
      ) as HTMLDivElement;

      overlay.onclick = () => {
        modal.style.display = "none";
      };
    },
    setUpAppointmentConfirmPage() {
      const serviceId = localStorage.getItem("serviceId");

      if (!serviceId) return;

      const url = `${API_URL}/v1/service?serviceId=${serviceId}`;
      fetch(url)
        .then((res) => res.json())
        .then((response) => {
          if (response.service) {
            const service: Service = response.service;
            const checkoutBtn = document.getElementById(
              "confirm-booking-btn"
            ) as HTMLButtonElement;
            // checkoutBtn.onclick = () => {
            //   const booking = JSON.parse(
            //     localStorage.getItem("service-booking") || ""
            //   );

            //   const pricing = service.advancedPricing.find(
            //     (ap) => ap.location === booking.location
            //   );

            //   const payload = {
            //     images: service.images as _File[],
            //     name: service.name,
            //     description: service.description,
            //     price: +(pricing?.price as number),
            //     quantity: 1,
            //     ratings: 0,
            //     _id: serviceId,
            //     type: "service" as const,
            //   };

            //   this.addProductToCart(payload);
            //   this.setUpCart();
            // };

            const files = response.service.images;

            const imageDiv = document.getElementById(
              "service-confirm-image"
            ) as HTMLDivElement;
            if (files.length) {
              const file = files[0];

              imageDiv.style.backgroundImage = `url(${API_URL}/v1/file/${file.filename})`;
            } else {
              imageDiv.style.backgroundPositionY = "-135px";
              imageDiv.style.backgroundImage = `url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAADhCAYAAAByfIirAAAFuUlEQVR4nO3dz2sUZxwH4I9LCCGEJYQgIhJCkBBEJEiQUnoo/ZtLz1Kkpx7EQw+l9CSliIRQQgkipYfXpY1ukt1kZmfemeeBXDTGF9/Zj+/P7yQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQOXudd0ArjVJspFkreuGjMhFkg9dN4L5fBD67VmSJ9FPq/RXkpdJzjpuB3NMum4AV1pPchhhtWrTJI+7bgTzCaz+ElTd8W/fUzqmHqdJ3nbdiIGajWb9B95zAqsep0led92IgdpMmQYKrJ7TQUA1BBZQDYEFVENgAdWw6D48O0l2U/r2Ism7JOedtggaIrCG42GS5ymB9bm3SX5OOcUN1RJYw3CUElZX9eejlFHXy5QRF1TJGlb9HuT6sJrZSPJNypkjqJLAqtski4XVzFaSp+01B9olsOq2k/lrVtfZS7mKAtURWHXbyfJ9uJ4y0oLqCKy63WbTZBL9TqU8uHW7uMWf+SfJx6YbAqsgsOp2muXD5+84SEqlBFbdzpL8ueSf+S39GGFNU2pQ7accuYAbOThav9cph0IX+dC/T/Jru81ZyGHKcYzZbuV5kp+yfPgyMkZY9TtN8io3v+nlLMmPC3xf2/aSvMjloxVbSb5Ncr+LBlEPgTUMfyT5Psnv+TKQzpO8SfJDul+72krydeY/d+uffs/0kCuZEg7HecpIayNlfWhWreE83Y+qktKer3P9odVpyujrVcpuJlwisIbnIrc77tC2Zyn3Hm+yn7KW1Ye1NnrGlJBV2Et5IeyinqdsJMAlAou2baZM85Z51taTfBV3HvmMwKJNk5TguU1Jm50kJ802h9oJLNr0NKV44G09TnLQUFsYAIFFWx6kmdpbJ0m2G/g5DIDAog2zM1VN7EJvpEwr7WgjsGjcJCWsmqy5dT9l55CRE1g07TDlGEMbP/cu62EMgMCiSbtJjlv62bMdR9VSR0xgjdtayi7cScoI5i7nntZS3srT5tmpzTS3NkaFdPx4zV779fB/v/YkpaLD6ZI/a5ISetNmmnatByntfLOCv4ueMcIarxe5HFZJCZzvsnzw7KecmVqVZ1GKZpQE1jgdpYTMPMtOu7az/NWbu5rES2FHSWCNzyIL4/cX+J5ksZIxbdnK6oOSjunscVnmUvFRvpwyfu443VZV2EvZLGAkBNa4vMjib4q+6QDofkqode0kStGMhsAaj4Msf5F4M/OvxUxTgqIPz88sWJVWHoE+PHC0bzu3L9XyMJdHUncpGdOW7bi6MwoCa/iaeLnDcf47RrBoqeNVO4j1rMETWMPXxML4bNp1kOVKHa/SJGWUpRTNgAmsYXuU5kYd0/T/WkyTZW3oIYE1XNOUtaYm+7iG52U31rMGq4YHkOWtpRxh6NPC+Cod5uqT/FRMYA3Tk9x86HPIJhl3YA+WwBqeByk7eWM3q0ZhPWtABNawzC4u69eiqRdh0BMe7OGYTYNU5Lxs7NPjQRFYw3GUdmqp125WCdV61gAIrGFos5b6EGykjD6tZ1VOYNXPYcnFKEUzAAKrbrN1K9dRFnOcft6DZEECq26P44DkMtayeAFDekhg1WuacgVFHy5nGqWVq6XT6rSe9t8BOGQHWe1bfmiIhdo6bSd5/+mL29lMef4/dt0QFiew6vTu0xeMisCqxySmgG3xOaiEjqrHXlwxaZPPQgV0Uj3Wor8YObuE/fUhyUXXjRips64bwHz3um4A19pNudRsZLU6p0l+id1DAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIA2/AvQNmMLb5ClIQAAAABJRU5ErkJggg==)`;
            }

            const dateField = document.getElementById(
              "service-date"
            ) as HTMLDivElement;
            const serviceField = document.getElementById(
              "service-field"
            ) as HTMLDivElement;
            const notesField = document.getElementById(
              "notes-field"
            ) as HTMLDivElement;
            const booking = JSON.parse(
              localStorage.getItem("service-booking") || ""
            );
            const date = new Date(booking.date).toLocaleString();
            dateField.innerHTML = date;
            serviceField.innerHTML = response.service.name;
            notesField.innerHTML = booking.notes || "";
          }
        });
    },
    getServicesForBooking() {
      const businessId = (this.role.business as Business)._id;
      const serviceId = localStorage.getItem("serviceId");

      const serviceField = document.getElementById(
        "service-field"
      ) as HTMLSelectElement;

      fetch(`${API_URL}/v1/service?businessId=${businessId}&limit=0`)
        .then((res) => res.json())
        .then((res) => {
          if (res.servicePage) {
            for (var i = 0; i < res.servicePage.docs.length; i++) {
              const option = document.createElement("option");

              option.value = res.servicePage.docs[i]._id;
              option.innerText = res.servicePage.docs[i].name;
              option.selected = res.servicePage.docs[i]._id === serviceId;

              serviceField.append(option);
            }
          }
        });

      serviceField.onchange = (ev: Event) => {
        const el = ev.target as HTMLSelectElement;
        localStorage.setItem("serviceId", el.value);
        this.setUpAppointmentPage();
      };

      this.setUpAppointmentPage();
    },
    setUpAppointmentDates(
      start = new Date(),
      end = new Date(
        (function get() {
          const date = new Date();
          date.setDate(date.getDate() + 9);
          return date;
        })()
      )
    ) {
      const startDate = new Date(start);
      const endDate = new Date(end);

      const dateRange = document.getElementById("date-range") as HTMLDivElement;

      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      dateRange.innerHTML = `${
        monthNames[startDate.getMonth()]
      } ${startDate.getDate()} - ${
        monthNames[endDate.getMonth()]
      } ${endDate.getDate()} ${endDate.getFullYear()}`;

      const dateItems = document.getElementById("date-items") as HTMLDivElement;

      dateItems.innerHTML = "";
      const slotsDiv = document.getElementById("time-slots") as HTMLDivElement;
      slotsDiv.innerHTML = "";

      for (
        let d = new Date(startDate);
        d < new Date(endDate);
        d.setDate(d.getDate() + 1)
      ) {
        const container = document.createElement("div");
        const div = document.createElement("div");
        const h3 = document.createElement("div");

        div.classList.add("day-text");
        h3.classList.add("date-text");

        div.innerHTML = new Date(d).toLocaleString("default", {
          weekday: "short",
        });
        h3.innerHTML = `${new Date(d).getDate()}`;

        const date = new Date(d);
        if (d.getTime() !== new Date(startDate).getTime()) {
          date.setHours(0);
          date.setMilliseconds(0);
          date.setMinutes(0);
          date.setSeconds(0);
        }
        container.id = `${new Date(date).toISOString()}`;

        container.onclick = () => {
          let cid = new Date(container.id);
          const end = new Date(cid);
          end.setDate(end.getDate() + 1);
          this.fetchSlots(
            `&startDate=${cid.toISOString()}&endDate=${end.toISOString()}`
          );
          const containers = document.querySelectorAll(".date-item");
          containers.forEach((item) =>
            item.classList.remove("date-item-clicked")
          );
          container.classList.toggle("date-item-clicked");
        };

        container.classList.add("date-item");

        container.append(div, h3);

        dateItems.append(container);
      }
    },
    configureDateButtons() {
      const prevDateBtn = document.getElementById(
        "prev-date-button"
      ) as HTMLButtonElement;
      const prevWeekBtn = document.getElementById(
        "prev-wk-button"
      ) as HTMLButtonElement;
      const backward = () => {
        const dateItems = document.getElementById(
          "date-items"
        ) as HTMLDivElement;
        const items = dateItems.querySelectorAll(".date-item");

        const time = items.item(0).id;
        const d = new Date(time);
        const startDate = new Date(time);
        startDate.setDate(startDate.getDate() - 9);

        this.setUpAppointmentDates(startDate, d);
      };

      prevDateBtn.onclick = backward;
      prevWeekBtn.onclick = backward;
      const nextDateBtn = document.getElementById(
        "next-date-button"
      ) as HTMLButtonElement;
      const nextWeekBtn = document.getElementById(
        "next-wk-button"
      ) as HTMLButtonElement;
      const forward = () => {
        const dateItems = document.getElementById(
          "date-items"
        ) as HTMLDivElement;
        const items = dateItems.querySelectorAll(".date-item");

        const time = items.item(items.length - 1).id;
        const d = new Date(time);
        const endDate = new Date(time);
        endDate.setDate(endDate.getDate() + 9);

        this.setUpAppointmentDates(d, endDate);
      };
      nextDateBtn.onclick = forward;
      nextWeekBtn.onclick = forward;
    },
    fetchSlots(params = "") {
      const serviceId = localStorage.getItem("serviceId");
      const url = `${API_URL}/v1/appointment/slots?serviceId=${serviceId}${params}`;

      if (!serviceId) return;

      fetch(url)
        .then((res) => res.json())
        .then((res) => {
          if (res.slots) {
            const slotsDiv = document.getElementById(
              "time-slots"
            ) as HTMLDivElement;
            slotsDiv.innerHTML = "";

            for (let i = 0; i < res.slots.length; i++) {
              const d = res.slots[i];
              const slotDiv = document.createElement("div");
              slotDiv.classList.add("time-slot");

              slotDiv.innerHTML = `${this.formatAMPM(
                new Date(d.from)
              )} - ${this.formatAMPM(new Date(d.end))}`;

              slotDiv.onclick = () => {
                const containers = document.querySelectorAll(".time-slot");
                containers.forEach((item) =>
                  item.classList.remove("time-slot-clicked")
                );
                slotDiv.classList.toggle("time-slot-clicked");
                const timeField = document.createElement("input");
                timeField.value = res.slots[i].from;
                timeField.name = "time";
                timeField.hidden = true;

                const form = document.getElementById(
                  "appointment-form"
                ) as HTMLFormElement;
                form.append(timeField);
              };

              slotsDiv.append(slotDiv);
            }
          }
        });
    },
    formatAMPM(date: Date) {
      var hours = date.getHours();
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      return hours + ampm;
    },
    addGallery() {
      const url = `${API_URL}/v1/gallery?shopId=${this.shop._id}&displayInImageSlider=true&limit=0`;

      fetch(url)
        .then((res) => res.json())
        .then((response) => {
          if (response.galleryPage?.docs && response.galleryPage.docs.length) {
            let galleryDiv = document.getElementById(
              "gallery-items"
            ) as HTMLDivElement;

            galleryDiv.innerHTML = "";

            for (let i = 0; i < response.galleryPage.docs.length; i++) {
              const files = response.galleryPage.docs[i].files;

              for (let index = 0; index < files.length; index++) {
                const file = files[index];

                const galleryItemDiv = document.createElement(
                  "img"
                ) as HTMLImageElement;

                galleryItemDiv.setAttribute("class", "gallery-image");

                galleryItemDiv.src = `${API_URL}/v1/file/${file.filename}`;

                galleryDiv.append(galleryItemDiv);
              }
            }
          }
        });
    },
    addContactForm() {
      const form = document.getElementById("contact-form") as HTMLFormElement;

      if (form) {
        form.onsubmit = (ev: Event) => {
          ev.preventDefault();

          // const data = new FormData(form);

          // const payload = {
          //   name: data.get("name"),
          //   email: data.get("email"),
          //   message: data.get("message"),
          // };

          // console.log("data: ", payload);
        };
      }
    },
    addShop() {
      const bid = (this.role.business as Business)._id;
      const url = `${API_URL}/v1/product/skus?businessId=${bid}`;

      fetch(url)
        .then((res) => res.json())
        .then((response) => {
          if (response.skus && response.skus.length) {
            this.showShop = true;
            let productDiv = document.getElementById(
              "products"
            ) as HTMLDivElement;

            productDiv.innerHTML = "";

            for (let i = 0; i < response.skus.length; i++) {
              const item = response.skus[i];
              const files = item.product.images;
              const productItemDiv = document.createElement(
                "div"
              ) as HTMLDivElement;

              productItemDiv.setAttribute("class", "product-item");

              const productImage = document.createElement(
                "img"
              ) as HTMLImageElement;

              productImage.setAttribute("class", "product-image");

              if (files.length) {
                const file = files[0];

                productImage.src = `${API_URL}/v1/file/${file.filename}`;
              } else {
                productImage.src = `data:image/png;base64,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`;
              }
              productItemDiv.append(productImage);
              const productDescSpan = document.createElement(
                "span"
              ) as HTMLSpanElement;

              productDescSpan.innerHTML = item.title;
              productDescSpan.setAttribute("class", "product-desc");

              const productPriceSpan = document.createElement(
                "span"
              ) as HTMLSpanElement;

              productPriceSpan.innerHTML = `KES ${item.pricing.retail_price}`;
              productPriceSpan.setAttribute("class", "product-price");

              const ratingDiv = document.createElement("div");
              const rating = item.product.ratings || 0;

              const fullStar = `
                <svg style="width:12px;height:12px" viewBox="0 0 24 24">
                  <path fill="#f48203" d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z" />
                </svg>
              `;
              const halfStar = `
                <svg style="width:12px;height:12px" viewBox="0 0 24 24">
                  <path fill="#f48203" d="M12 2L9.19 8.62L2 9.24L7.45 13.97L5.82 21L12 17.27V2Z" />
                </svg>
              `;
              const emptyStar = `
                <svg style="width:12px;height:12px" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M12,15.39L8.24,17.66L9.23,13.38L5.91,10.5L10.29,10.13L12,6.09L13.71,10.13L18.09,10.5L14.77,13.38L15.76,17.66M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z" />
                </svg>              
              `;

              if (rating >= 1)
                ratingDiv.innerHTML = ratingDiv.innerHTML + fullStar;
              else if (rating > 0 && rating % 1 > 0)
                ratingDiv.innerHTML = ratingDiv.innerHTML + halfStar;
              else ratingDiv.innerHTML = ratingDiv.innerHTML + emptyStar;

              if (rating >= 2)
                ratingDiv.innerHTML = ratingDiv.innerHTML + fullStar;
              else if (rating > 1 && rating % 2 > 1)
                ratingDiv.innerHTML = ratingDiv.innerHTML + halfStar;
              else ratingDiv.innerHTML = ratingDiv.innerHTML + emptyStar;

              if (rating >= 3)
                ratingDiv.innerHTML = ratingDiv.innerHTML + fullStar;
              else if (rating > 2 && rating % 3 > 2)
                ratingDiv.innerHTML = ratingDiv.innerHTML + halfStar;
              else ratingDiv.innerHTML = ratingDiv.innerHTML + emptyStar;

              if (rating >= 4)
                ratingDiv.innerHTML = ratingDiv.innerHTML + fullStar;
              else if (rating > 3 && rating % 4 > 3)
                ratingDiv.innerHTML = ratingDiv.innerHTML + halfStar;
              else ratingDiv.innerHTML = ratingDiv.innerHTML + emptyStar;

              if (rating >= 5)
                ratingDiv.innerHTML = ratingDiv.innerHTML + fullStar;
              else if (rating > 4 && rating % 5 > 4)
                ratingDiv.innerHTML = ratingDiv.innerHTML + halfStar;
              else ratingDiv.innerHTML = ratingDiv.innerHTML + emptyStar;

              ratingDiv.append(rating.toFixed(2));

              ratingDiv.style.textAlign = "left";
              ratingDiv.style.display = "flex";
              ratingDiv.style.alignItems = "center";

              productItemDiv.append(
                productDescSpan,
                productPriceSpan,
                ratingDiv
              );

              productItemDiv.addEventListener("click", () => {
                // location.href = `/shop/${product._id}`;
                this.setProduct(item);
              });

              productDiv?.append(productItemDiv);
            }
          }
        });
    },
    setProduct(item: SKU) {
      const productImage = document.getElementById(
        "product-detail-image"
      ) as HTMLImageElement;

      const files = item.product.images;

      if (files.length) {
        let file: _File = files[0];

        productImage.src = `${API_URL}/v1/file/${file.filename}`;

        const productCarouselContainerDiv = document.getElementById(
          "product-carousel-container"
        ) as HTMLDivElement;
        const productCarouselDiv = document.getElementById(
          "product-carousel"
        ) as HTMLDivElement;

        productCarouselContainerDiv.style.display = "none";

        for (let i = 0; i < files.length; i++) {
          file = files[i];
          const img = document.createElement("img");

          img.src = `${API_URL}/v1/file/${file.filename}`;
          img.setAttribute("class", "product-carousel-image");
          productCarouselDiv.append(img);
        }

        productCarouselContainerDiv.style.display = "flex";
      } else {
        productImage.src = `data:image/png;base64,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`;
      }

      const productPriceDiv = document.getElementById(
        "product-detail-price"
      ) as HTMLDivElement;

      const productDescDiv = document.getElementById(
        "product-description"
      ) as HTMLDivElement;

      productPriceDiv.innerHTML = `KES${item.pricing.retail_price}`;
      productDescDiv.innerHTML =
        item.product.description || item.product.short_description;

      const productDetailDiv = document.getElementById(
        "product-detail"
      ) as HTMLDivElement;
      productDetailDiv.innerHTML = item.title;
      // productImageDiv.prepend(productImage);
      const recommendationsDiv = document.getElementById(
        "recommendations"
      ) as HTMLDivElement;
      const productDiv = document.getElementById("products") as HTMLDivElement;

      recommendationsDiv.innerHTML = productDiv.innerHTML;
      recommendationsDiv.style.display = "flex";

      const cartButton = document.getElementById(
        "add-to-cart-button"
      ) as HTMLButtonElement;

      cartButton.addEventListener("click", () => {
        this.addProductToCart({
          images: item.product.images,
          price: item.pricing.retail_price,
          name: item.title,
          description:
            item.product.description || item.product.short_description,
          _id: item._id,
          quantity: 1,
          ratings: item.product.ratings,
          type: "product",
        });

        this.setUpCart();
      });
      const ratingDiv = document.createElement("div");
      const rating = item.product.ratings || 0;

      const fullStar = `
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path fill="#f48203" d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z" />
                </svg>
              `;
      const halfStar = `
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path fill="#f48203" d="M12 2L9.19 8.62L2 9.24L7.45 13.97L5.82 21L12 17.27V2Z" />
                </svg>
              `;
      const emptyStar = `
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M12,15.39L8.24,17.66L9.23,13.38L5.91,10.5L10.29,10.13L12,6.09L13.71,10.13L18.09,10.5L14.77,13.38L15.76,17.66M22,9.24L14.81,8.63L12,2L9.19,8.63L2,9.24L7.45,13.97L5.82,21L12,17.27L18.18,21L16.54,13.97L22,9.24Z" />
                </svg>              
              `;

      if (rating >= 1) ratingDiv.innerHTML = ratingDiv.innerHTML + fullStar;
      else if (rating > 0 && rating % 1 > 0)
        ratingDiv.innerHTML = ratingDiv.innerHTML + halfStar;
      else ratingDiv.innerHTML = ratingDiv.innerHTML + emptyStar;

      if (rating >= 2) ratingDiv.innerHTML = ratingDiv.innerHTML + fullStar;
      else if (rating > 1 && rating % 2 > 1)
        ratingDiv.innerHTML = ratingDiv.innerHTML + halfStar;
      else ratingDiv.innerHTML = ratingDiv.innerHTML + emptyStar;

      if (rating >= 3) ratingDiv.innerHTML = ratingDiv.innerHTML + fullStar;
      else if (rating > 2 && rating % 3 > 2)
        ratingDiv.innerHTML = ratingDiv.innerHTML + halfStar;
      else ratingDiv.innerHTML = ratingDiv.innerHTML + emptyStar;

      if (rating >= 4) ratingDiv.innerHTML = ratingDiv.innerHTML + fullStar;
      else if (rating > 3 && rating % 4 > 3)
        ratingDiv.innerHTML = ratingDiv.innerHTML + halfStar;
      else ratingDiv.innerHTML = ratingDiv.innerHTML + emptyStar;

      if (rating >= 5) ratingDiv.innerHTML = ratingDiv.innerHTML + fullStar;
      else if (rating > 4 && rating % 5 > 4)
        ratingDiv.innerHTML = ratingDiv.innerHTML + halfStar;
      else ratingDiv.innerHTML = ratingDiv.innerHTML + emptyStar;

      ratingDiv.append(
        `${rating.toFixed(2)} out of (${item.product.reviewCount}) Reviews`
      );

      ratingDiv.style.textAlign = "left";
      ratingDiv.style.display = "flex";
      ratingDiv.style.alignItems = "center";
      ratingDiv.style.fontSize = "18px";
      ratingDiv.style.fontWeight = "400";

      productDetailDiv.append(ratingDiv);
    },
    addProductToCart(product: ShopCartItem) {
      const cart: ShopCartItem[] =
        JSON.parse(localStorage.getItem("cart") as string) || [];

      const indx = cart.findIndex((item) => item._id === product._id);

      if (indx === -1) cart.push({ ...product, quantity: 1 });
      else if (indx > -1) cart[indx].quantity += 1;

      localStorage.setItem("cart", JSON.stringify(cart));
    },
    removeProductFromCart(product: ShopCartItem) {
      const cart: ShopCartItem[] =
        JSON.parse(localStorage.getItem("cart") as string) || [];

      const indx = cart.findIndex((item) => item._id === product._id);

      if (indx !== -1) cart.splice(indx, 1);

      localStorage.setItem("cart", JSON.stringify(cart));

      this.setUpCart();
    },
    setUpCart() {
      const cartTableBody = document.getElementById(
        "cart-table-body"
      ) as HTMLElement;
      if (!cartTableBody) return;
      cartTableBody.innerHTML = "";
      const cartItems: ShopCartItem[] =
        JSON.parse(localStorage.getItem("cart") as string) || [];

      for (let i = 0; i < cartItems.length; i++) {
        const element = cartItems[i];
        const files = element.images;

        const td1 = document.createElement("td");
        const img = document.createElement("img");
        const div = document.createElement("div");
        const descDiv = document.createElement("div");
        const span1 = document.createElement("span");
        const span2 = document.createElement("span");

        if (files.length) {
          let file = files[0];

          img.src = `${API_URL}/v1/file/${file.filename}`;
        } else {
          img.src = `data:image/png;base64,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`;
        }
        span1.innerHTML = element.name;
        span2.id = `${element._id}-qty`;
        span2.innerHTML = `Qty: ${element.quantity}`;
        div.style.display = "flex";

        img.classList.add("cart-product-img");
        span2.style.color = "#f48203";
        descDiv.classList.add("desc-div");

        descDiv.append(span1, span2);
        div.append(img, descDiv);
        td1.append(div);

        const td2 = document.createElement("td");
        td2.innerHTML = `KES ${element.price}`;

        const td3 = document.createElement("td");
        const qtyDiv = document.createElement("div");
        qtyDiv.style.display = "flex";
        qtyDiv.style.alignItems = "center";

        const minusBtn = document.createElement("button");
        minusBtn.classList.add("qty-btn");
        minusBtn.innerHTML = `
          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
            <path fill="#f48203" d="M19,13H5V11H19V13Z" />
          </svg>
        `;
        minusBtn.onclick = () => {
          const field = document.getElementById(
            `${element._id}-qty-field`
          ) as HTMLInputElement;
          if (parseInt(field?.value) > 1) {
            const cart: ShopCartItem[] =
              JSON.parse(localStorage.getItem("cart") as string) || [];

            const indx = cart.findIndex((item) => item._id === element._id);

            cart[indx].quantity -= 1;

            localStorage.setItem("cart", JSON.stringify(cart));
            const qty = `${parseInt(field?.value) - 1}`;
            field.value = qty;
            const qtyDisplay = document.getElementById(
              `${element._id}-qty`
            ) as HTMLSpanElement;
            qtyDisplay.innerHTML = `Qty: ${qty}`;
            const amntTd = document.getElementById(
              `${element._id}-amnt`
            ) as HTMLTableCellElement;
            amntTd.innerHTML = `KES ${parseInt(qty) * element.price}`;
            const total = cart
              .map((i) => i.price * i.quantity)
              .reduce((a, b) => a + b, 0);

            const totalTd = document.getElementById(
              "total-display"
            ) as HTMLTableCellElement;
            totalTd.innerHTML = `KES ${total}`;
          }
        };

        const qtyField = document.createElement("input");
        qtyField.id = `${element._id}-qty-field`;
        qtyField.style.border = "1px solid #ccc";
        qtyField.style.width = "40px";
        qtyField.style.height = "30px";
        qtyField.style.textAlign = "center";
        qtyField.value = `${element.quantity}`;

        const plusBtn = document.createElement("button");
        plusBtn.classList.add("qty-btn");
        plusBtn.innerHTML = `
          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
            <path fill="#f48203" d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
          </svg>
        `;
        plusBtn.onclick = () => {
          this.addProductToCart(element);
          const field = document.getElementById(
            `${element._id}-qty-field`
          ) as HTMLInputElement;
          const qty = `${parseInt(field?.value) + 1}`;
          field.value = qty;
          const qtyDisplay = document.getElementById(
            `${element._id}-qty`
          ) as HTMLSpanElement;
          qtyDisplay.innerHTML = `Qty: ${qty}`;
          const amntTd = document.getElementById(
            `${element._id}-amnt`
          ) as HTMLTableCellElement;
          amntTd.innerHTML = `KES ${parseInt(qty) * element.price}`;

          const cart: ShopCartItem[] =
            JSON.parse(localStorage.getItem("cart") as string) || [];
          const total = cart
            .map((i) => i.price * i.quantity)
            .reduce((a, b) => a + b, 0);

          const totalTd = document.getElementById(
            "total-display"
          ) as HTMLTableCellElement;
          totalTd.innerHTML = `KES ${total}`;
        };

        qtyDiv.append(minusBtn, qtyField, plusBtn);
        td3.append(qtyDiv);

        const deleteBtn = document.createElement("button");
        deleteBtn.classList.add("acttion-btn");
        deleteBtn.innerHTML = `
          <svg style="width:24px;height:24px" viewBox="0 0 24 24">
            <path fill="#f48203" d="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z" />
          </svg>
        `;
        deleteBtn.onclick = () => {
          this.removeProductFromCart(element);
        };

        const favBtn = document.createElement("button");
        favBtn.classList.add("action-btn");
        favBtn.innerHTML = `
          <svg style="width:24px;height:24px" viewBox="0 0 24 24">
            <path fill="#f48203" d="M12.1,18.55L12,18.65L11.89,18.55C7.14,14.24 4,11.39 4,8.5C4,6.5 5.5,5 7.5,5C9.04,5 10.54,6 11.07,7.36H12.93C13.46,6 14.96,5 16.5,5C18.5,5 20,6.5 20,8.5C20,11.39 16.86,14.24 12.1,18.55M16.5,3C14.76,3 13.09,3.81 12,5.08C10.91,3.81 9.24,3 7.5,3C4.42,3 2,5.41 2,8.5C2,12.27 5.4,15.36 10.55,20.03L12,21.35L13.45,20.03C18.6,15.36 22,12.27 22,8.5C22,5.41 19.58,3 16.5,3Z" />
          </svg>
        `;
        favBtn.onclick = () => {
          console.log("fav: ", element._id);
        };

        const trTopDiv = document.createElement("div");
        trTopDiv.style.textAlign = "right";
        trTopDiv.append(favBtn, deleteBtn);

        const td4 = document.createElement("td");
        td4.id = `${element._id}-amnt`;
        td4.innerHTML = `KES ${element.price * element.quantity}`;
        td4.style.color = "#f48203";

        const tr2 = document.createElement("tr");
        tr2.classList.add("cart-table-tr");

        tr2.append(td1, td2, td3, td4);

        const td5 = document.createElement("td");
        td5.style.color = "#f48203";
        td5.colSpan = 2;
        td5.innerHTML = element.name;
        const selectCheckbox = document.createElement("input");
        selectCheckbox.type = "checkbox";
        selectCheckbox.value = element._id;
        selectCheckbox.id = `${element._id}-checkbox`;
        selectCheckbox.onchange = (e) => {
          const checkbox = document.getElementById(
            `${element._id}-checkbox`
          ) as HTMLInputElement;
          if (checkbox.checked)
            console.log(
              "selected: ",
              (e.target as EventTarget & { value: string }).value
            );
        };
        td5.prepend(selectCheckbox);
        const td6 = document.createElement("td");
        td6.colSpan = 2;
        td6.prepend(trTopDiv);
        const tr1 = document.createElement("tr");
        tr1.classList.add("cart-table-tr");

        tr1.append(td5, td6);

        const trSpacer = document.createElement("tr");
        const tdSpacer = document.createElement("td");
        trSpacer.classList.add("tr-spacer");
        tdSpacer.colSpan = 4;
        trSpacer.append(tdSpacer);

        cartTableBody.append(tr1, tr2, trSpacer);
      }

      if (cartItems.length) {
        const total = cartItems
          .map((i) => i.price * i.quantity)
          .reduce((a, b) => a + b, 0);
        const td1 = document.createElement("td");
        td1.innerHTML = "Total";
        td1.colSpan = 3;
        td1.style.fontSize = "36px";
        td1.style.fontWeight = "600";

        const td2 = document.createElement("td");
        td2.id = "total-display";
        td2.innerHTML = `KES ${total}`;
        td2.style.fontWeight = "700";
        td2.style.fontSize = "36px";
        td2.style.color = "#f48203";
        td2.style.textAlign = "text-align: right";

        const tr1 = document.createElement("tr");
        tr1.classList.add("cart-table-tr");

        tr1.append(td1, td2);

        const td3 = document.createElement("td");
        td3.colSpan = 4;
        td3.style.textAlign = "right";

        const btn1 = document.createElement("button");
        btn1.style.border = "1px solid #f48203";
        btn1.style.color = "#f48203";
        btn1.style.background = "#fff";
        btn1.style.width = " 190px";
        btn1.style.height = "40px";
        btn1.innerHTML = "CONTINUE SHOPPING";
        btn1.addEventListener("click", () => {
          location.href = "/shop.html";
        });

        const btn2 = document.createElement("button");
        btn2.style.border = "1px solid #fff";
        btn2.style.color = "#fff";
        btn2.style.background = "#f48203";
        btn2.style.width = " 210px";
        btn2.style.height = "40px";
        btn2.innerHTML = "PROCEED TO CHECKOUT";
        btn2.addEventListener("click", () => {
          location.href = "/payment.html";
        });

        td3.append(btn1, btn2);

        const tr2 = document.createElement("tr");
        tr2.classList.add("cart-table-tr");

        tr2.append(td3);

        cartTableBody.append(tr1, tr2);
        const similarProductsDiv = document.getElementById(
          "similar-products"
        ) as HTMLDivElement;
        const productDiv = document.getElementById(
          "products"
        ) as HTMLDivElement;

        similarProductsDiv.innerHTML = productDiv.innerHTML;
        similarProductsDiv.style.display = "flex";
      } // else cartTableBody.innerHTML = "No items in cart";
    },
    setUpOrder() {
      const cart: ShopCartItem[] =
        JSON.parse(localStorage.getItem("cart") as string) || [];

      if (cart.length) {
        const orderItems = document.getElementById(
          "order-items"
        ) as HTMLElement;

        for (let i = 0; i < cart.length; i++) {
          const item = cart[i];

          const hr = document.createElement("hr");
          hr.classList.add("cart-item-hr");

          const itemNameDiv = document.createElement("div");
          itemNameDiv.innerHTML = `${item.quantity} X ${item.name}`;

          const itemOptionsDiv = document.createElement("div");
          if (item.option_set?.length) {
            const optionsB = document.createElement("b");
            optionsB.innerHTML = `OPTIONS: `;
            itemOptionsDiv.append(optionsB);
            item.option_set.map((option) => {
              optionsB.append(`${option.option_name} `);
              option.option_values.map((opt) => optionsB.append(opt.value));
            });
          }

          const itemCostDiv = document.createElement("div");
          itemCostDiv.classList.add("cart-item-cost");
          itemCostDiv.innerHTML = `KES ${item.quantity * item.price}`;

          const cartItemDescDiv = document.createElement("div");
          cartItemDescDiv.classList.add("cart-item-desc");

          cartItemDescDiv.append(hr, itemNameDiv, itemOptionsDiv, itemCostDiv);

          if (item.type === "product") {
            const cartItemShippingDiv = document.createElement("div");
            cartItemShippingDiv.style.background = "#fee8e0";
            cartItemShippingDiv.style.padding = "5px";

            const div = document.createElement("div");
            div.innerHTML = "SHIPPING METHOD";
            const shippingMethodDiv = document.createElement("div");
            shippingMethodDiv.classList.add("shipping-method-title");

            cartItemShippingDiv.append(div, shippingMethodDiv);

            cartItemDescDiv.append(cartItemShippingDiv);
          }

          const cartItemImageDiv = document.createElement("div");
          cartItemImageDiv.style.margin = "10px";

          if (item.images.length) {
            const img = `${API_URL}/v1/file/${item.images[0].filename}`;
            const cartItemImage = document.createElement("img");
            cartItemImage.classList.add("cart-item-image");
            cartItemImage.src = img;

            cartItemImageDiv.append(cartItemImage);
          }

          const cartItemDiv = document.createElement("div");
          cartItemDiv.classList.add("cart-item");
          cartItemDiv.append(cartItemDescDiv, cartItemImageDiv);

          orderItems.append(cartItemDiv);
        }

        const amountDiv = document.createElement("div");
        const total = cart
          .map((i) => i.price * i.quantity)
          .reduce((a, b) => a + b, 0);
        amountDiv.innerHTML = `Amount Payable: KES ${total}`;
        orderItems.append(amountDiv);
      }
    },
    addCardPaymentForm() {
      const form = document.getElementById(
        "payment-card-form"
      ) as HTMLFormElement;

      if (!form) return;

      form.onsubmit = (ev: Event) => {
        ev.preventDefault();

        const data = new FormData(form);

        const payload = {
          fullname: data.get("card_holder_name"),
          card_number: data.get("card_number"),
          expiry_month: data.get("expiry_month"),
          expiry_year: data.get("expiry_year"),
          cvv: data.get("cvv"),
          amount: data.get("payment-amount-field"),
        };

        console.log("payment data: ", payload);

        const cart: ShopCartItem[] =
          JSON.parse(localStorage.getItem("cart") as string) || [];

        const paymentAmountDiv = document.getElementById(
          "payment-amount"
        ) as HTMLDivElement;
        const modal = document.getElementById(
          "payment-modal-overlay"
        ) as HTMLDivElement;
        modal.style.display = "block";
        const total = cart
          .map((i) => i.price * i.quantity)
          .reduce((a, b) => a + b, 0);
        paymentAmountDiv.style.color = "#f48203";
        paymentAmountDiv.innerHTML = `KES ${total}`;
      };
    },
    preventLink(e: Event) {
      e.preventDefault();
    },
    addProductCategories() {
      const allCategoryLabel = document.getElementById(
        "all-categories-label"
      ) as HTMLDivElement;

      if (!allCategoryLabel) return;

      allCategoryLabel.onclick = () => {
        const categoriesDiv = document.getElementById(
          "categories"
        ) as HTMLDivElement;

        const chevronRight = document.getElementById(
          "chevron-right"
        ) as HTMLElement;
        const chevronDown = document.getElementById(
          "chevron-down"
        ) as HTMLElement;

        chevronRight.style.display = "none";
        chevronDown.style.display = "block";

        const bid = (this.role.business as Business)._id;
        const url = `${API_URL}/v1/product/category?businessId=${bid}`;

        fetch(url)
          .then((res) => res.json())
          .then((response) => {
            if (
              response.categoryPage?.docs &&
              response.categoryPage.docs.length
            ) {
              categoriesDiv.innerHTML = "";
              for (let i = 0; i < response.categoryPage.docs.length; i++) {
                const productCategory = response.categoryPage.docs[i];

                const catDiv = document.createElement("div");

                catDiv.style.cursor = "pointer";
                catDiv.innerHTML = productCategory.category_name;
                catDiv.onclick = () => {
                  // TODO: fetch by category
                  this.addShop();
                };

                categoriesDiv.append(catDiv);
                categoriesDiv.style.display = "block";
              }
            }
          });
      };

      const expandedFilters = document.getElementById(
        "expanded-filters"
      ) as HTMLDivElement;
      const expandedState = document.getElementById(
        "expanded-state"
      ) as HTMLInputElement;
      const itemsDiv = document.getElementById(
        "expanded-items"
      ) as HTMLDivElement;

      expandedFilters.onclick = () => {
        const chevronUp = document.getElementById(
          "filters-chevron-up"
        ) as HTMLElement;
        const chevronDown = document.getElementById(
          "filters-chevron-down"
        ) as HTMLElement;

        if (expandedState.value === "expanded") {
          chevronUp.style.display = "none";
          chevronDown.style.display = "block";
          itemsDiv.style.display = "none";
          expandedState.value = "collapsed";
        } else if (expandedState.value === "collapsed") {
          chevronUp.style.display = "block";
          chevronDown.style.display = "none";
          itemsDiv.style.display = "block";
          expandedState.value = "expanded";
        }
      };
    },
    openLinkMenu(ev: Event, el: HTMLDivElement) {
      ev.preventDefault();
      this.el = { name: "", item: el };
      this.linkMenuDialog = true;
    },
    resizeLogo(ev: Event) {
      ev.preventDefault();
      this.resizeLogoDialog = true;
    },
    removeShopName(ev: Event) {
      ev.preventDefault();
      this.showShopName = false;
    },
    toggleFullscreen() {
      /* View in fullscreen */
      if (!this.fullScreen) {
        const elem = document.getElementById("viewer") as HTMLElement & {
          webkitRequestFullscreen: () => void;
          msRequestFullscreen: () => void;
        }; // documentElement
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) {
          /* Safari */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          /* IE11 */
          elem.msRequestFullscreen();
        }
        return;
      }

      /* Close fullscreen */
      const doc = document as Document & {
        webkitExitFullscreen: () => void;
        msExitFullscreen: () => void;
      };
      if (doc.exitFullscreen) {
        doc.exitFullscreen();
      } else if (doc.webkitExitFullscreen) {
        /* Safari */
        doc.webkitExitFullscreen();
      } else if (doc.msExitFullscreen) {
        /* IE11 */
        doc.msExitFullscreen();
      }
    },
    setUpVouchers() {
      const vouchersDiv = document.getElementById("vouchers") as HTMLDivElement;

      const bid = (this.role.business as Business)._id;
      const url = `${API_URL}/v1/voucher?businessId=${bid}`;

      fetch(url)
        .then((res) => res.json())
        .then((response) => {
          if (response.voucherPage?.docs && response.voucherPage.docs.length) {
            this.showVouchers = true;
            vouchersDiv.innerHTML = "";
            for (let i = 0; i < response.voucherPage.docs.length; i++) {
              const voucher = response.voucherPage.docs[i];

              const vDiv = document.createElement("div");

              vDiv.classList.add("voucher-item");
              vDiv.innerHTML = `${voucher.name || ""}
              <br /> ${voucher.description || ""}
              <br />${voucher.currency} ${voucher.value}`;
              vDiv.style.background = voucher.color;
              vDiv.onclick = () => {
                // show voucher
              };

              vouchersDiv.append(vDiv);
            }
          }
        });
    },
    setUpMemberships() {
      const membershipsDiv = document.getElementById(
        "memberships"
      ) as HTMLDivElement;

      const bid = (this.role.business as Business)._id;
      const url = `${API_URL}/v1/membership?businessId=${bid}`;

      fetch(url)
        .then((res) => res.json())
        .then((response) => {
          if (
            response.membershipPage?.docs &&
            response.membershipPage.docs.length
          ) {
            this.showMembership = true;
            membershipsDiv.innerHTML = "";
            for (let i = 0; i < response.membershipPage.docs.length; i++) {
              const membership = response.membershipPage.docs[i];
              const mImg = document.createElement("img");
              mImg.setAttribute("class", "membership-image");

              if (membership.images.length) {
                const file = membership.images[0];

                mImg.src = `${API_URL}/v1/file/${file.filename}`;
              } else {
                mImg.src = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAADhCAYAAAByfIirAAAFuUlEQVR4nO3dz2sUZxwH4I9LCCGEJYQgIhJCkBBEJEiQUnoo/ZtLz1Kkpx7EQw+l9CSliIRQQgkipYfXpY1ukt1kZmfemeeBXDTGF9/Zj+/P7yQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQOXudd0ArjVJspFkreuGjMhFkg9dN4L5fBD67VmSJ9FPq/RXkpdJzjpuB3NMum4AV1pPchhhtWrTJI+7bgTzCaz+ElTd8W/fUzqmHqdJ3nbdiIGajWb9B95zAqsep0led92IgdpMmQYKrJ7TQUA1BBZQDYEFVENgAdWw6D48O0l2U/r2Ism7JOedtggaIrCG42GS5ymB9bm3SX5OOcUN1RJYw3CUElZX9eejlFHXy5QRF1TJGlb9HuT6sJrZSPJNypkjqJLAqtski4XVzFaSp+01B9olsOq2k/lrVtfZS7mKAtURWHXbyfJ9uJ4y0oLqCKy63WbTZBL9TqU8uHW7uMWf+SfJx6YbAqsgsOp2muXD5+84SEqlBFbdzpL8ueSf+S39GGFNU2pQ7accuYAbOThav9cph0IX+dC/T/Jru81ZyGHKcYzZbuV5kp+yfPgyMkZY9TtN8io3v+nlLMmPC3xf2/aSvMjloxVbSb5Ncr+LBlEPgTUMfyT5Psnv+TKQzpO8SfJDul+72krydeY/d+uffs/0kCuZEg7HecpIayNlfWhWreE83Y+qktKer3P9odVpyujrVcpuJlwisIbnIrc77tC2Zyn3Hm+yn7KW1Ye1NnrGlJBV2Et5IeyinqdsJMAlAou2baZM85Z51taTfBV3HvmMwKJNk5TguU1Jm50kJ802h9oJLNr0NKV44G09TnLQUFsYAIFFWx6kmdpbJ0m2G/g5DIDAog2zM1VN7EJvpEwr7WgjsGjcJCWsmqy5dT9l55CRE1g07TDlGEMbP/cu62EMgMCiSbtJjlv62bMdR9VSR0xgjdtayi7cScoI5i7nntZS3srT5tmpzTS3NkaFdPx4zV779fB/v/YkpaLD6ZI/a5ISetNmmnatByntfLOCv4ueMcIarxe5HFZJCZzvsnzw7KecmVqVZ1GKZpQE1jgdpYTMPMtOu7az/NWbu5rES2FHSWCNzyIL4/cX+J5ksZIxbdnK6oOSjunscVnmUvFRvpwyfu443VZV2EvZLGAkBNa4vMjib4q+6QDofkqode0kStGMhsAaj4Msf5F4M/OvxUxTgqIPz88sWJVWHoE+PHC0bzu3L9XyMJdHUncpGdOW7bi6MwoCa/iaeLnDcf47RrBoqeNVO4j1rMETWMPXxML4bNp1kOVKHa/SJGWUpRTNgAmsYXuU5kYd0/T/WkyTZW3oIYE1XNOUtaYm+7iG52U31rMGq4YHkOWtpRxh6NPC+Cod5uqT/FRMYA3Tk9x86HPIJhl3YA+WwBqeByk7eWM3q0ZhPWtABNawzC4u69eiqRdh0BMe7OGYTYNU5Lxs7NPjQRFYw3GUdmqp125WCdV61gAIrGFos5b6EGykjD6tZ1VOYNXPYcnFKEUzAAKrbrN1K9dRFnOcft6DZEECq26P44DkMtayeAFDekhg1WuacgVFHy5nGqWVq6XT6rSe9t8BOGQHWe1bfmiIhdo6bSd5/+mL29lMef4/dt0QFiew6vTu0xeMisCqxySmgG3xOaiEjqrHXlwxaZPPQgV0Uj3Wor8YObuE/fUhyUXXjRips64bwHz3um4A19pNudRsZLU6p0l+id1DAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIA2/AvQNmMLb5ClIQAAAABJRU5ErkJggg==`;
              }

              const mDiv = document.createElement("div");

              mDiv.classList.add("membership-item");
              mDiv.innerHTML = `${membership.name || ""}`;
              mDiv.append(mImg);
              mDiv.onclick = () => {
                const membershipWrapper = document.getElementById(
                  "membership-form-wrapper"
                ) as HTMLDivElement;
                const membershipId = document.getElementById(
                  "membership-id"
                ) as HTMLInputElement;

                membershipWrapper.style.display = "block";
                membershipId.value = membership._id;
              };

              membershipsDiv.append(mDiv);
            }
          }
        });
    },
    addForm(f: Form) {
      const formFields = document.getElementById(
        "dynamic-form-fields"
      ) as HTMLFormElement;
      const formTitle = document.getElementById(
        "dynamic-form-title"
      ) as HTMLDivElement;

      const formId = document.getElementById("formId") as HTMLInputElement;
      formId.innerHTML = f._id;

      formTitle.innerHTML = f.name;
      f.formFields.map((field) => {
        const fieldWrapper = document.createElement("div");

        fieldWrapper.classList.add("field-wrapper");

        const label = document.createElement("label");

        label.innerText = field.settings.label;

        if (field.name === "SelectField") {
          const input = document.createElement("select");

          fieldWrapper.append(label);

          input.classList.add("form-control");
          input.required = field.settings.isRequired;
          input.name = field._id as string;
          input.multiple = field.multiple;

          field.options.map((op) => {
            const option = document.createElement("option");
            option.value = op;
            option.innerText = op;

            input.append(option);
          });

          if (field.settings.showPlaceholder) {
            input.setAttribute("placeholder", field.settings.placeholder);
          }

          fieldWrapper.append(input);
        } else if (field.name === "TextField") {
          const input = document.createElement("input");

          input.classList.add("form-control");
          input.required = field.settings.isRequired;
          input.type = field.type as string;
          input.name = field._id as string;

          if (field.settings.showPlaceholder) {
            input.setAttribute("placeholder", field.settings.placeholder);
          }

          fieldWrapper.append(input);
        } else if (field.name === "TextAreaField") {
          const input = document.createElement("textarea");

          input.classList.add("form-control");
          input.required = field.settings.isRequired;
          input.name = field._id as string;

          if (field.settings.showPlaceholder) {
            input.setAttribute("placeholder", field.settings.placeholder);
          }

          fieldWrapper.append(input);
        }

        if (field.settings.showHint) {
          const hint = document.createElement("span");

          hint.innerHTML = field.settings.hint;
          fieldWrapper.append(hint);
        }

        formFields.append(fieldWrapper);
      });
      this.form = f;
      this.formDialog = false;

      const frm = document.getElementById("dynamic-form") as HTMLFormElement;

      frm.onsubmit = (ev) => {
        ev.preventDefault();

        const data = new FormData(frm);

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const payload = {} as any;
        for (var i = 0; i < f.formFields.length; i++) {
          const field = f.formFields[i];
          payload[field._id as string] = data.get(field._id as string);
        }

        console.log("data: ", payload);
      };
    },
    getServiceCategories() {
      const bid = (this.role.business as Business)._id;
      this.fetchServiceCategoryList(`?businessId=${bid}`).then((page) => {
        if (page && page.docs.length) {
          const divs = document.querySelectorAll(
            ".service-categories-list-container"
          );

          divs.forEach((div) => {
            div.innerHTML = "";
            for (let i = 0; i < page.docs.length; i++) {
              const element = page.docs[i];

              const p = document.createElement("p");
              p.innerHTML = element.name;
              div?.append(p);
            }
          });
        }
      });
    },
    applyThemeColor() {
      document.querySelectorAll(".social-icon-svg").forEach((svgPath) => {
        svgPath.setAttribute("fill", this.themeColor);
      });

      const sections = [
        "home",
        "services",
        "gallery",
        "shop",
        "contact",
        "productDetail",
        "cart",
        "payment",
        "membership",
        "voucher",
        "form",
        "bookService",
        "login",
        "register",
        "forgot-password",
        "location",
      ];

      for (let i = 0; i < sections.length; i++) {
        const id = sections[i];

        const doc = document.getElementById(id);

        const main = document.getElementById(`${id}-main`);

        if (main) main.style.color = this.themeColor;

        doc?.querySelectorAll("a").forEach((el) => {
          el.style.color = this.themeColor;
        });

        doc?.querySelectorAll("path").forEach((el) => {
          el.setAttribute("fill", this.themeColor);
        });

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        doc?.querySelectorAll(".logo-shop").forEach((el: any) => {
          el.style.color = this.themeColor;
        });

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        doc?.querySelectorAll(".shop-link").forEach((el: any) => {
          el.style.color = this.themeColor;
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        doc?.querySelectorAll("a.active").forEach((el: any) => {
          el.style.color = "#fff";
        });

        if (id === "shop") {
          const catLabel = doc?.querySelector(
            ".all-categories-label"
          ) as HTMLDivElement;
          const filters = doc?.querySelector(
            ".expanded-filters"
          ) as HTMLDivElement;
          const shopMenuTitle = doc?.querySelector(
            ".shop-menu-title"
          ) as HTMLDivElement;

          catLabel.style.color = this.themeColor;
          filters.style.color = this.themeColor;
          shopMenuTitle.style.color = this.themeColor;
        }

        if (id === "payment") {
          let btn = document.getElementById("make-payment-button");
          if (btn) btn.style.background = this.themeColor;
          btn = document.getElementById("pay-button");
          if (btn) btn.style.background = this.themeColor;
        }

        if (id === "membership") {
          let btn = document.getElementById("purchase-sub-button");
          if (btn) btn.style.background = this.themeColor;

          btn = document.getElementById("membership-ok");
          if (btn) btn.style.background = this.themeColor;
        }

        if (id === "contact") {
          let btn = document.querySelector(".button") as HTMLButtonElement;

          btn.style.background = this.themeColor;
        }

        const sectionTitle = doc?.querySelector(
          ".section-title"
        ) as HTMLDivElement;

        if (sectionTitle) {
          sectionTitle.style.color = this.themeColor;
        }

        if (doc) doc.style.color = this.themeColor;
      }
      const shopBtn = document.querySelector(".shop-button") as HTMLElement;
      const appointmentBtn = document.querySelector(
        ".schedule-button"
      ) as HTMLElement;
      const title = document.getElementById(
        "home-title-heading"
      ) as HTMLElement;

      shopBtn.style.background = this.themeColor;
      appointmentBtn.style.color = this.themeColor;
      title.style.color = this.themeColor;

      this.themeColorDialog = false;
    },
    setColors(el: HTMLElement) {
      this.colors = {
        bgColor:
          "#" +
          rgbaHex(
            window.getComputedStyle(el).getPropertyValue("background-color")
          ),
        fontColor:
          "#" + rgbaHex(window.getComputedStyle(el).getPropertyValue("color")),
      };
    },
    itemRemoved(arg: { item: HTMLElement; name: string }) {
      this.removedElements.push(arg);
      this.fontDialog = false;
    },
    undoRemoval(index: number) {
      this.removedElements[index].item.style.display = "block";
      this.removedElements.splice(index, 1);
    },
    zoomIn() {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const page = document.getElementById("page-container") as any; //HTMLDivElement
      this.zoomLevel += 0.25;
      // .style.transform = `scale(${this.zoomLevel})`;
      page.style.zoom = this.zoomLevel;
    },
    zoomOut() {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const page = document.getElementById("page-container") as any; // HTMLDivElement
      this.zoomLevel -= 0.25;
      // view.style.transform = `scale(${this.zoomLevel})`;
      page.style.zoom = this.zoomLevel;
    },
  },
  beforeCreate() {
    if (!this.$store.hasModule("SITE_SHOP_DETAIL")) {
      this.$store.registerModule("SITE_SHOP_DETAIL", shopStoreModule);
    }
    if (!this.$store.hasModule("SITE")) {
      this.$store.registerModule("SITE", siteStoreModule);
    }
    if (!this.$store.hasModule("SITE_SERVICES")) {
      this.$store.registerModule("SITE_SERVICES", serviceStoreModule);
    }
    if (!this.$store.hasModule("TERMS")) {
      this.$store.registerModule("TERMS", termsStoreModule);
    }
    if (!this.$store.hasModule("CANCELLATION_POLICY")) {
      this.$store.registerModule(
        "CANCELLATION_POLICY",
        cancellationPolicyStoreModule
      );
    }
    if (!this.$store.hasModule("LOCATION_LIST")) {
      this.$store.registerModule("LOCATION_LIST", locationStoreModule);
    }
    if (!this.$store.hasModule("SERVICE_CAT_LIST")) {
      this.$store.registerModule(
        "SERVICE_CAT_LIST",
        serviceCategoryStoreModule
      );
    }
  },
  beforeDestroy() {
    this.$store.unregisterModule("SITE_SHOP_DETAIL");
    this.$store.unregisterModule("SITE");
    this.$store.unregisterModule("SITE_SERVICES");
    this.$store.unregisterModule("TERMS");
    this.$store.unregisterModule("CANCELLATION_POLICY");
    this.$store.unregisterModule("LOCATION_LIST");
    this.$store.unregisterModule("SERVICE_CAT_LIST");
  },
});
